import { createAxios } from "./axiosHttpMarconi";

export const partnerService = {
  partnerSolucion,
  partnerRMA,
  getPartnerByCode,
};

function partnerSolucion(idIncidencia, body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/cliente/${user.extraData.clienteId}/partner/incidencia/${idIncidencia}`;
  return axios.post(urlPath, body);
}

function partnerRMA(id, tk, req) {
  const axios = createAxios();
  let urlPath = `partner/rma/${id}?tk=${tk}`;
  return axios.post(urlPath, req);
}

function getPartnerByCode(code) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  const clienteId = user?.extraData?.clienteId;
  const urlPath = `/cliente/${clienteId}/partner/${code}`;
  return axios.get(urlPath);
}
